import { useState, useEffect } from 'react';

export default (ref, enabled = true, options = {}) => {
  const { offset } = {
    offset: 0,
    ...options,
  };
  const [admin, setAdmin] = useState(0);
  const [top, setTop] = useState(0);
  const [parentTop, setParentTop] = useState(0);
  const [sticky, setSticky] = useState(null);

  useEffect(() => {
    function onResize() {
      setSticky(null);
    }

    if (enabled) {
      window.addEventListener('resize', onResize);
      onResize();
    }

    return function cleanup() {
      window.removeEventListener('resize', onResize);
    };
  }, [enabled]);

  useEffect(() => {
    if (ref.current && sticky === null && enabled) {
      const rect = ref.current.getBoundingClientRect();
      const parentRect = ref.current.parentNode.getBoundingClientRect();

      const yScroll = window.pageYOffset || document.documentElement.scrollTop;
      setTop(rect.top + yScroll);
      setParentTop(parentRect.top + yScroll);

      const adminBar = document.getElementById('adminbar');
      if (adminBar) {
        setAdmin(adminBar.offsetHeight);
      }
    }
  }, [ref, sticky, enabled]);

  useEffect(() => {
    function onScroll() {
      if (ref.current) {
        const yScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        const distance = yScroll - top + offset + admin;

        const parentBottom =
          parentTop + ref.current.parentNode.offsetHeight - admin - yScroll;

        setSticky(sticky => {
          if (ref.current.offsetHeight > ref.current.parentNode.offsetHeight) {
            return null;
          }
          if (sticky === 'sticky-bottom') {
            if (parentBottom - ref.current.offsetHeight - offset > 0) {
              return 'sticky-top';
            }
            return 'sticky-bottom';
          }
          if (sticky === 'sticky-top') {
            if (parentBottom < ref.current.offsetHeight + offset) {
              return 'sticky-bottom';
            }
          }
          if (distance >= 0) {
            return 'sticky-top';
          }
          return null;
        });
      }
    }
    if (enabled) {
      window.addEventListener('scroll', onScroll);
      onScroll();
    }

    return function cleanup() {
      window.removeEventListener('scroll', onScroll);
    };
  });

  return sticky;
};
